$( document ).ready(function() {     
      $(".grid-item").on("click", "div , button", function (event) {  
         setTimeout(function() { 
            if ($('.image-wrap.vw-parent').hasClass("active")) {
               $('video').trigger('play');                
             }
         }, 200);      
      });  
});
  